import React from 'react';
import { Link } from 'react-router-dom';
import './admin.css';

const Sidebar = () => {
  return (
    <div className="sidebar">
      <h2 className="logo">Admin</h2>
      <nav>
        <Link to="dashboard">Dashboard</Link>
        <Link to="addbook">Add Book</Link>
        <Link to="viewbook">View Book</Link>
        <Link to="user">Users</Link>
        <Link to="order">Orders</Link>
      </nav>
    </div>
  );
};

export default Sidebar;
